<template>
	<div>
		<page-title-bar></page-title-bar>
		<v-container fluid grid-list-xl pt-0>
			<app-card>

			<v-layout row wrap>
					<v-flex xs12 sm12>
						<span class="small pt-4 d-block">
						<div v-show="kindmail === 6" style="color:red;">Mail wanneer klant afspraak heeft verwijderd online<br><br></div>
						<div v-show="kindmail === 5" style="color:red;">Mail naar klant wachtwoord vergeten <br>
						Enkel wanneer modules > Online reservatie > Snel afrekenen is uitgeschakeld<br></div>
						<div v-show="kindmail === 4" style="color:red;">Mail naar klant nieuw account met wachtwoord<br>
						Enkel wanneer modules > Online reservatie > Snel afrekenen is uitgeschakeld<br></div>
						
					
						<div v-show="kindmail < 100">
							Variabelen : <br>
						<span><strong>[DATUM]</strong> Datum afspraak  <br> </span>	
						<span><strong>[NAAM]</strong> Voornaam klant  <br></span>
						<span><strong>[ACHTERNAAM]</strong> Achternaam / fam. naam klant  <br></span>
						<span><strong>[EMAIL]</strong> Email klant  <br></span>
						<div v-show="kindmail === 1"><span><strong>[OPMERKING]</strong> Opmerking ingegeven door klant <br></span></div>
						</div>

					<div v-show="kindmail < 3">
						<span><strong>[DATUM]</strong> Datum afspraak  <br> </span>
						<span><strong>[UUR]</strong> Begintijdstip afspraak (=1e afspraak)  <br></span>
						<span><strong>[AFSPRAKEN]</strong> Lijst gekozen afspraken door klant <br></span>
						<span><strong>[MIJNAFSPRAKENLINK]</strong> Link (url) klant afspraken  (a href tags)  <br></span>
					</div>
						<div v-show="kindmail === 5">
						<span><strong>[WACHTWOORD]</strong> Wachtwoord klant  <br> </span>
					</div>
						<div v-show="kindmail === 4">
						<span><strong>[WACHTWOORD]</strong> Wachtwoord klant  <br> </span>
					</div>
						</span>
					</v-flex>
					<v-flex xs12 sm8>
					<div v-show="kindmail < 100">
					<v-text-field name="inputsubject" label="Geef onderwerp in" id="inputsubject" v-model="inputsubject"></v-text-field>
					</div>
					</v-flex>
				</v-layout>
				<v-layout row wrap>
					<div v-show="kindmail < 100">
					<v-flex xs12 class="col-height-auto"><v-checkbox color="primary" input-value="true" value v-model="sendcopy" label="Zend ook een kopie naar de winkel"></v-checkbox></v-flex>
					</div>
					</v-layout>
				<wysiwyg v-model="myHTML" />
			</app-card>
			<app-card>
				<v-btn color="success" @click="save" name="btnsave" :disabled="disable">Opslaan</v-btn>
				</app-card>
		</v-container>
	</div>
</template>

<script>

import myHttpApi from "../../api/myHttpApi"

var dataRec = null;

export default {
  props: ['kindmail'],
  data: function() {
    return {
			myHTML: "",
			sendcopy: false,
      inputsubject: "",
			disable: false,
			dataRec: {}
    };
	},
	mounted() {
    this.getData();
  },
  watch: {
    kindmail (newId, oldId) {
        this.kindmail = newId;
        this.disable = false;
        this.getData();
    }
  },
  methods: {
    getData() {
      myHttpApi
		const searchRec = {Search: this.kindmail, Extra: ""}
        console.log (searchRec);
        
		myHttpApi.post('BOSettings/Mail', searchRec)
        .then(response => {
          console.log (response.data);
          this.loader = false;
					this.myHTML = response.data.MailMsg;
					this.inputsubject = response.data.Subject;
					this.sendcopy = response.data.IsSendCopy;
					this.dataRec = response.data;
        })
        .catch(error => {
          console.log(error);
        });
		},
		save () {
				this.dataRec.MailMsg = this.myHTML;
				this.dataRec.Subject = this.inputsubject;
				this.dataRec.IsSendCopy = this.sendcopy;
				myHttpApi.post('BOSettings/MailSave', this.dataRec)
                .then(response => {
                this.loader = false;
                            console.log ("Ok saved");
                            this.disable = true;
                })
                .catch(error => {
                console.log(error);
                });
        }
  }
};
</script>